<template>
    <!-- <v-img
      :src="require('@/assets/img/smartphone.png')"
      style="position: absolute"
      contain
      width="300"
      height="500"
    /> -->

    <v-card
        flat
        class="elevation-0"
        style="border-radius: 15px; border: 5px solid #000 !important"
    >
        <v-card-title class="d-flex justify-center py-2">
            <v-icon color="blacknew">mdi-circle-medium</v-icon>
        </v-card-title>
        <v-card-text class="pa-0" width="100%">
            <v-card flat color="#f3f5f7" class="py-2">
                <div
                    class="font-weight-600 blacknew--text mb-2 font-size-18 px-4 py-2"
                >
                    {{ preview.mapel }}
                </div>

                <v-card v-if="preview.wacana" flat class="ma-0 mb-2">
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-title class="text-body-2 black--text">
                                <p
                                    v-if="!!preview.wacana"
                                    style="white-space: pre-line"
                                    v-html="parseLatex(preview.wacana)"
                                ></p>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
                <v-card flat class="mx-0 mb-2">
                    <v-list-item two-line>
                        <v-list-item-content>
                            <div
                                class="text-body-2 black--text"
                                style="white-space: pre-line"
                                v-html="parseLatex(preview.soal)"
                            ></div>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
                <v-card
                    v-if="
                        preview.tipe_pilihan === 'single' ||
                        preview.tipe_pilihan === 'multiple' ||
                        preview.tipe_pilihan === 'truefalse'
                    "
                    flat
                    class="mx-0 my-2"
                >
                    <v-list>
                        <v-list-item
                            two-line
                            style="min-height: none !important"
                        >
                            <v-list-item-content>
                                <v-list-item-subtitle
                                    class="font-weight-bold black--text pa-0"
                                >
                                    Pilihan Jawaban
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-card
                            v-if="
                                preview.tipe_pilihan === 'single' ||
                                preview.tipe_pilihan === 'multiple'
                            "
                            v-for="(jawaban, i) in preview.pilihan"
                            :key="i"
                            v-show="jawaban.value"
                            elevation="0"
                            class="mx-4 my-2 mb-3"
                            color="#f3f5f7"
                        >
                            <div
                                cols="1"
                                class="pa-2 d-flex align-center"
                                :class="
                                    jawaban.answer === true
                                        ? 'bg-success text-white'
                                        : 'blacknew--text'
                                "
                            >
                                <span
                                    class="font-weight-bold px-2 mr-1"
                                    :class="
                                        jawaban.answer === true
                                            ? 'white--text'
                                            : 'primary--text'
                                    "
                                >
                                    {{ jawaban.key }}
                                </span>
                                <div v-html="parseLatex(jawaban.value)"></div>
                            </div>
                        </v-card>

                        <div
                            class="mx-4 my-2 mb-4"
                            v-if="preview.tipe_pilihan === 'truefalse'"
                        >
                            <table width="100%" cellpadding="10">
                                <tr style="background-color: #f3f5f7">
                                    <td width="60%" class="pa-3">Pernyataan</td>
                                    <td class="pa-3" align="center">Benar</td>
                                    <td class="pa-3" align="center">Salah</td>
                                </tr>
                                <tr
                                    v-for="(jawaban, i) in preview.pilihan"
                                    style="border-top: 1px solid #ebebeb"
                                    v-show="jawaban.value"
                                >
                                    <td class="pa-3" width="40%">
                                        <div
                                            v-html="parseLatex(jawaban.value)"
                                        ></div>
                                    </td>
                                    <td
                                        class="pa-3 text-center"
                                        :class="
                                            jawaban.answer === true
                                                ? 'bg-success text-white'
                                                : 'bg-error'
                                        "
                                    >
                                        <v-icon
                                            v-if="jawaban.answer"
                                            color="white"
                                            style="font-size: 20px"
                                        >
                                            mdi-check-circle
                                        </v-icon>
                                    </td>

                                    <td
                                        class="pa-3 text-center"
                                        :class="
                                            !jawaban.answer
                                                ? 'bg-success text-white'
                                                : 'bg-error'
                                        "
                                    >
                                        <v-icon
                                            v-if="!jawaban.answer"
                                            color="white"
                                            style="font-size: 20px"
                                        >
                                            mdi-check-circle
                                        </v-icon>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </v-list>
                </v-card>

                <v-card
                    v-if="preview.tipe_pilihan === 'inputtext'"
                    flat
                    class="mx-0 my-2"
                >
                    <v-list>
                        <v-list-item
                            two-line
                            style="min-height: none !important"
                        >
                            <v-list-item-content>
                                <v-list-item-subtitle
                                    class="font-weight-bold black--text pa-0"
                                >
                                    Jawaban
                                </v-list-item-subtitle>
                                <div v-html="parseLatex(preview.key)"></div>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>

                <v-card flat class="mx-0 my-2">
                    <v-list>
                        <v-list-item
                            two-line
                            style="min-height: none !important"
                        >
                            <v-list-item-content>
                                <v-list-item-subtitle
                                    class="font-weight-bold black--text pa-0"
                                >
                                    Pembahasan
                                </v-list-item-subtitle>
                                <div
                                    v-html="parseLatex(preview.explanation)"
                                ></div>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-card>
        </v-card-text>
        <v-card-actions class="py-3">
            <v-row>
                <v-col>
                    <v-btn depressed @click="$emit('close')" block rounded>
                        Kembali
                    </v-btn>
                </v-col>
                <v-col>
                    <v-btn
                        color="blew"
                        dark
                        depressed
                        :loading="loading"
                        block
                        rounded
                        @click="$emit('validate')"
                    >
                        Validasi
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
import katex from "katex";
import showdown from "showdown";
export default {
    name: "wacana",
    props: ["preview", "loading"],
    data: function () {
        return {
            loading: false,
        };
    },
    methods: {
        parseLatex: function (content) {
            var converter = new showdown.Converter();

            var compiledContent = content.replace(/&gt;/g, ">");
            compiledContent = compiledContent.replace(/&lt;/g, "<");
            compiledContent = compiledContent.replace(/&amp;/g, "&");

            compiledContent = this.compileInlineLatex(compiledContent);
            compiledContent = this.compileBlockLatex(compiledContent);

            return converter.makeHtml(compiledContent);
        },

        compileInlineLatex: function (content) {
            var pattern = /\\\\\((.*?)\\\\\)/g;
            var compiledContent = content;
            var match;

            // eslint-disable-next-line
            while ((match = pattern.exec(compiledContent))) {
                var index = match.index;
                var length = match[0].length;
                var formula = katex.renderToString(match[1], { trust: true });
                compiledContent =
                    compiledContent.substr(0, index) +
                    formula +
                    compiledContent.substr(index + length);
            }

            return compiledContent;
        },

        compileBlockLatex: function (content) {
            var pattern = /\$\$(.*?)\$\$/g;
            var compiledContent = content;
            var match;

            // eslint-disable-next-line
            while ((match = pattern.exec(compiledContent))) {
                var index = match.index;
                var length = match[0].length;
                var formula =
                    '<p class="text-center">' +
                    katex.renderToString(match[1], { trust: true }) +
                    "</p>";
                compiledContent =
                    compiledContent.substr(0, index) +
                    formula +
                    compiledContent.substr(index + length);
            }
            return compiledContent;
        },
    },
};
</script>

<style>
.bg-error {
    background-color: #ff9f9e !important;
}
</style>



// WEBPACK FOOTER //
// Preview.vue?77f353a4